import { IUserObjectStore } from '../index'

export default function(state: IUserObjectStore): IUserObjectStore {
  return {
    ...state,
    profileRequest: {
      ...state.profileRequest,
      isSaving: true,
    },
  }
}
